{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Stack Maps ID",
      "folder": "Pool Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "domainTypeAttributes": {
      "options": ["AB", "BC", "MB", "SK"],
    },
    "ui": {
      "label": "Province",
      "folder": "Pool Header",
      "width": 100,
      "isShownByDefault": true,
    },
  },
  "field_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field Code",
      "folder": "Pool Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "pool_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pool Code",
      "folder": "Pool Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "formation_code": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation Code",
      "folder": "Pool Header",
      "isShownByDefault": true,
      "tnum": true,
    },
  },
  "field_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Field Name",
      "folder": "Pool Header",
      "isShownByDefault": true,
    },
  },
  "pool_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Pool Name",
      "folder": "Pool Header",
      "width": 200,
      "isShownByDefault": true,
    },
  },
  "formation_name": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Formation Name",
      "folder": "Pool Header",
      "width": 200,
      "isShownByDefault": true,
    },
  },
  "geometry": {
    "source": "regulator",
    "domainType": "Geometry",
    "ui": {
      "label": "N/A",
      "folder": "N/A",
      "isNotRenderable": true,
    },
  },
}
